import { render, staticRenderFns } from "./TrafficLightRankIndicator.vue?vue&type=template&id=517d86a3&scoped=true&"
import script from "./TrafficLightRankIndicator.vue?vue&type=script&lang=js&"
export * from "./TrafficLightRankIndicator.vue?vue&type=script&lang=js&"
import style0 from "./TrafficLightRankIndicator.vue?vue&type=style&index=0&id=517d86a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d86a3",
  null
  
)

export default component.exports